import { createAsyncThunk } from "@reduxjs/toolkit";
import { getDominanciaTalentosService } from "../../../../services/dashboard/dominanciaTalentos/dominanciaTalentos.services";

export const getDominanciaTalentosThunk = createAsyncThunk(
  "dominanciaTalentos/getDominanciaTalentos",
  async (_, { getState, rejectWithValue }) => {
    try {
      const { escuela, plantel } = getState().dashboardFilters;
      return await getDominanciaTalentosService({ escuela, plantel });
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error obteniendo dominancia de talentos"
      );
    }
  }
);
